import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'app/_services/dashboard.service';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';
import { ProjectsService } from 'app/_services/projects.service';
import { ReportService } from 'app/_services/report.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
const moment = require('moment');
import * as html2pdf from 'html2pdf.js';
declare var global: any;
var Color = global.Color;

import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
@Component({
  selector: 'app-dashboard8',
  templateUrl: './dashboard8.component.html',
  styleUrls: ['./dashboard8.component.scss']
})

export class Dashboard8Component implements OnInit {

  isLoading = false;
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  notSpam2 = false;
  sentiments = [];
  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };
  currentTag = null;
  modalRef: BsModalRef;

  brandDropDownSettings = {
    singleSelection: false,
    text: 'Chọn thương hiệu',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 2,
  };
  projectDropDownSettings = {
    singleSelection: false,
    enableSearchFilter: true,
    text: 'Chọn chủ đề',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    badgeShowLimit: 2,
  };
  isShowChart3 = false;

  brandSelected = [];
  brands = [];

  projectSelected = [];
  projects = [];

  data_facebook = true;
  showSuggestPost = false;
  docTypeSelected = [{ 'id': 1, 'itemName': 'FACEBOOK', value: 'page_post user_post group_post' }];
  allDocTypes = [
    { 'id': 1, 'itemName': 'FACEBOOK', value: 'page_post user_post group_post' },
    // {'id': 2, 'itemName': 'NEWS', value: 'news_article news_blog news_forum'},
    // {'id': 3, 'itemName': 'YOUTUBE', value: 'youtube"'},
    // {'id': 4, 'itemName': 'TIKTOK', value: 'tiktok'},

    // {'id': 5, 'itemName': 'INSTAGRAM', value: '"instagram"'},
    // {'id': 6, 'itemName': 'LINKEDIN', value: '"linkedin"'},
    // {'id': 7, 'itemName': 'TWITTER', value: '"twitter"'}
  ]
  configAngularMultiSelect = {
    singleSelection: false,
    text: 'Vui lòng chọn',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 2,
  };
  tags = [];

  projectsDisscussion = [];
  projectsDisscussionSelected = [];


  public lineChartData = [
    // { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
  ];
  public lineChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  public lineChartOptions = {
    responsive: true,
  };

  public lineChartColors = [
    {
      borderColor: '#4EBD74',
   
      backgroundColor: 'rgb(255, 255, 255)'
    },
    {
       borderColor: '#FF6262',
       backgroundColor: 'rgb(255, 255, 255)'
  
    },
    {
      borderColor: '#FFC107',
      backgroundColor: 'rgb(255, 255, 255)'

    },
    {
      borderColor: '#5C88DC',
      backgroundColor: 'rgb(255, 255, 255)'
    }
  ];


  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];

  public doughnutChartType = 'doughnut';
  public doughnutChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      labels: false
    },
    legend: {
      display: false,
      labels: {
        fontSize: 12,
      }
    },
  }
  public doughnutChartColors = [
    { backgroundColor: ["#4EBD74", "#FE2A2A", "#D9D9D9"] }
  ];

  public doughnutChartLabels = ['Tích cực', 'Tiêu cực', 'Trung tính'];

  public barChartColours: Array<any> = [
		{ // Series B2f7347
			backgroundColor: Color('#8FD0A5').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#FF6262').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ // Series B
			backgroundColor: Color('#5C88DC').alpha(0.8).rgbString(),
			borderWidth: 1
		},
		{ 
			backgroundColor: Color('#FFC107').alpha(0.8).rgbString(),
			borderWidth: 1
		}
	];
	barChartType = 'bar';
  barChart3Options  = {
    // scaleShowVerticalLines: false,
    // responsive: false
    maintainAspectRatio: false,
    plugins: {
      labels: false
    },
    tooltips: {
      mode: 'index',
      intersect: false,
      position: 'nearest',
      // convert to % . author : vdthuan
      callbacks: {
        label: function (tooltipItem, data) {
          var index = tooltipItem.index;
          var currentValue = data.datasets[tooltipItem.datasetIndex].data[index];
          var total = 0;
          data.datasets.forEach(function (el) {
            total = total + el.data[index];
          });
          var percentage = parseFloat((currentValue / total * 100).toFixed(1)) || 0;
          return currentValue + ' (' + percentage + '%)';
        }
        // ,
        // title: function (tooltipItem, data) {
        //     return data.datasets[tooltipItem[0].datasetIndex].label;
        // }
      }
    },
    scales: {
      xAxes: [{
        display: true,
        stacked: true,
        barPercentage: 0.6,
        ticks: {
          beginAtZero: true,
          fontColor: '#B3B3B3'

        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        },
        distribution: 'series',
        // type: 'time',
        time: {
          displayFormats: {
            quarter: 'MMM DD'
          },
          // unit: 'hour'
        }
      }],
      responsive: true,
      yAxes: [{
        stacked: true,
        display: true,
        ticks: {
          beginAtZero: true,
          fontColor: '#B3B3B3'
        },
        gridLines: {
          color: '#5f5e5e'  // grid line color (can be removed or changed)
        },
        scaleLabel: {
          display: false,
          labelString: 'Thảo luận',
          fontColor: '#0099ff'
        }
      }]
    },
    legend: {
      usePointStyle: true,
      display: true,
      labels: {
        fontSize: 12,
        fontColor: '#0099ff'
      }
      // onClick: this.mainBarChartClicked,
    },
  };;
	barChart3Labels: string[] = [];
	barChart3Data: any[] = [
		// { data: [], label: 'Vinaphone' },
		// { data: [], label: 'vnpt' },
		// { data: [], label: 'VNPT pay' }
	];
  sources = [];

  public barChartOptions = {
    plugins: {
      labels: {
        render: 'value',
        fontColor: 'black',
        precision: 2,
        arc: true,
        fontSize: 14,
        fontStyle: 'bold'
      }
    }
  };
  public barChartLabels = ['Vinaphone', 'VNPT', 'Mobifone', 'VietnamMobile'];
  public barChartLegend = true;
  public barChartPlugins = [];

  showChart1 = false;
  showChart2 = false;
  public barChartData = [
    // { data: [65, 59, 80, 81], label: 'Số thảo luận' },
    // { data: [28, 48, 40, 19], label: 'Chỉ số NSR' }
  ];
  public barChartColors: Color[] = [
    { backgroundColor: '#8FD0A5' },
    { backgroundColor: '#c10e45' }
  ]

  constructor(
    private projectsService: ProjectsService,
    private dashboardService: DashboardService,
    private toastrService: ToastrService
  ) {

  }

  ngOnInit() {
    this.getBrands();
    this.getProject();
  }





  getBrands() {
    this.projectsService.getBrandsActiveV2().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name,
            fanpageId: element.fanpageId ? element.fanpageId : null
          };
          this.brands.push(obj);
        });
      }
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        for (let index = 0; index < response.data.projects.length; index++) {
          const element = response.data.projects[index];
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(obj);
        }
      }
    });
  }
  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }


  getProjectDiscussion() {
    this.projectsDisscussion = [];
    this.projectsDisscussionSelected = [];
    this.projectsService.getProjectDiscussionByProject({ projects: this.projectSelected }).subscribe(res => {
      if (res.success) {
        res.data.projectsDiscussion
          .forEach(element => {
            let obj = {
              id: element._id,
              itemName: element.name,
              value: element.name
            };
            this.projectsDisscussion.push(obj);
          });
      }
    })
  }

  getDataFromServer() {
    if ((this.brandSelected.length && this.brandSelected.length  > 1 && this.brandSelected.length < 5) ||
     (this.projectSelected.length  && this.projectSelected.length  > 1 &&  this.projectSelected.length < 5) ) { 
      if(this.projectsDisscussionSelected.length == 0 || this.projectsDisscussionSelected.length == 1) {
        this.getChart1();
        this.getChart2();
        this.getChart3();
        this.getChart4();
      } else {
        this.toastrService.warning("Vui lòng chọn tối đa 1 chủ đề thảo luận", "Thông báo")
      }
  

    } else {
      this.toastrService.warning("Vui lòng chọn từ 2 đến 4 chủ đề hoặc thương hiệu", "Thông báo")

    }
  }


  getChart1() {
      this.showChart1 = false;
      const filter = {
        gte: new Date(this.daterangeFilter.start.format('YYYY-MM-DDTHH:mm:ss.SSSZ')).getTime(),
        lte: new Date(this.daterangeFilter.end.format('YYYY-MM-DDTHH:mm:ss.SSSZ')).getTime(),
        projects: this.projectSelected,
        brands: this.brandSelected,
        // type: this.typeReport,
        index: 'full',
        notSpam : this.notSpam2
      };
      this.dashboardService.getSentimentReport({ filter: filter,  index: 'full' }).subscribe(response => {
        let data = response.data;
        if (data) {

          this.barChartLabels = [];
          this.barChartData = [];
          this.barChartData = [
            {data : [], label : 'Chỉ số NSR'}
          ]
          this.sentiments = [];



          let aggregations = data.aggregations;
          for (var _key in aggregations) {
            let sentiment = {};

            for (var _idx in aggregations[_key].statistic.docTypesCount.sentimentsCount.statistic.seg.buckets) {
              let sentimentDetail = aggregations[_key].statistic.docTypesCount.sentimentsCount.statistic.seg.buckets[_idx]
              sentiment[sentimentDetail.key] = sentimentDetail.doc_count;
            }
            
            const reportItem = {
              name: _key,
              totalNews: aggregations[_key].statistic.docTypesCount.news.doc_count || 0,
              totalPosts: aggregations[_key].statistic.docTypesCount.post.doc_count || 0,
              commentCount: aggregations[_key].statistic.docTypesCount.comment.doc_count || 0,
              doughnutChartData : [[(sentiment['pos'] || 0 ), (sentiment['neg'] || 0 ), (sentiment['neu'] || 0 ) ]],
              pos : (sentiment['pos'] || 0 ),
              neg: (sentiment['neg'] || 0 ),
              neu : (sentiment['neu'] || 0 ),
              totalSentiment : (sentiment['pos'] || 0 ) + (sentiment['neg'] || 0 ) + (sentiment['neu'] || 0 )
            }
            this.sentiments.push(reportItem);

            let nsr = 0;
            let posPercent = ((sentiment['pos'] || 0 ) / reportItem.totalSentiment) * 100;
            let negPercent = (((sentiment['neg'] || 0) / reportItem.totalSentiment) * 100 );
            nsr = ((posPercent - negPercent) / (posPercent + negPercent)) * 100;
            this.barChartLabels.push(_key);
            this.barChartData[0].data.push(nsr.toFixed(2));
          }
          this.showChart1 = true;
        }
      });


  }



  async exportPDF() {
    this.isLoading = true;
    let totalExported = 0;
    let pages = Array.from(window.document.getElementsByClassName('container-page'));

    const options = {
      margin: 0,
      filename: `bao_cao_so_sanh_thuong_hieu.pdf`,
      image: { type: 'jpeg', quality: 1 },

      html2canvas: { dpi: 250, scrollX: 0, scrollY: 0, width: 1587, height: 1122 },
      jsPDF: { orientation: 'landscape', format: 'a3' }
    }
    let worker = html2pdf().set(options).from(pages[0]);
    totalExported++;
    if (totalExported == pages.length) {
      this.isLoading = false;
    }
    if (pages.length > 1) {
      worker = worker.toPdf() // worker is now a jsPDF instance

      // add each element/page individually to the PDF render process
      pages.slice(1).forEach((element, index) => {
        worker = worker
          .get('pdf')
          .then(pdf => {
            pdf.addPage();
            totalExported++;
            if (totalExported == (pages.length)) {
              this.isLoading = false;
            }
          })
          .from(element)
          .toContainer()
          .toCanvas()
          .toPdf()
      })
    }

    worker = worker.save();

  }


  getChart2() { 
    this.showChart2 = false;
    const filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      notSpam: this.notSpam2,
      index: 'full' 
    };

    this.dashboardService.discussion({ filter: filter, index: 'full' }).subscribe(response => {
      let data = response.data;
      if (data) {
        this.lineChartLabels = [];
        this.lineChartData = [
          // { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' }
        ]

        this.brandSelected.forEach(brand => {
          this.lineChartData.push({
            label: brand.itemName,
            data: []
          })
        });
        this.projectSelected.forEach(brand => {
          this.lineChartData.push({
            label: brand.itemName,
            data: []
          })
        });

        let aggregations = data.aggregations;
        for (var _key in aggregations.byDay.buckets) {
          this.lineChartLabels.push(aggregations.byDay.buckets[_key].key_as_string);
          this.lineChartData.forEach(brand => {
            let totalPost = aggregations.byDay.buckets[_key][brand.label].statistic.docTypesCount.doc_count || 0;
            brand.data.push((totalPost));
          });
        }

      }
      this.showChart2 = true;

    });
  }

  getChart3() {
    this.isShowChart3 = false;
    const filter = {
			projectsSelected : this.projectSelected,
			brandsSelected : this.brandSelected,
			gte: this.daterangeFilter.start.valueOf(),
			lte: this.daterangeFilter.end.valueOf(),
			notSpam: this.notSpam2,
			index  :'full',
		}
    const options3 = {
			filter: filter,
			mode: 'chart3',
			index  :'full'
		}
		this.dashboardService.getTrademarkData(options3).subscribe(res => {
			if (res.success) {
			   this.isShowChart3 = true;
				this.mappingDataChart3(res.discussProjects, res.data.aggregations)
			}
		});
  }

  getChart4() {
    const filter = {
			projectsSelected : this.projectSelected,
			brandsSelected : this.brandSelected,
			gte: this.daterangeFilter.start.valueOf(),
			lte: this.daterangeFilter.end.valueOf(),
			notSpam: this.notSpam2,
			index  :'full',
		}
    const options = {
			filter: filter,
			mode: 'chart2',
			index  :'full'
		}
		this.dashboardService.getTrademarkData(options).subscribe(res => {
			if (res.success) {
        this.mappingDataChart4(res.data.aggregations)
			}
		});
  }

  async mappingDataChart3(discussProjects, data) {
		this.barChart3Labels = [];
		this.barChart3Data = [];


		this.brandSelected.forEach(item => {
			const dataItem = {
				data: [], label: item.itemName, mappingData: {}
			}
			this.barChart3Data.push(dataItem);
		});

		this.projectSelected.forEach(item => {
			const dataItem = {
				data: [], label: item.itemName, mappingData: {}
			}
			this.barChart3Data.push(dataItem);
		});

		// let await1s = await this.resolveAfter1Seconds()

    let discussProjectss = this.projectsDisscussionSelected.length ? this.projectsDisscussionSelected : discussProjects

		discussProjectss.forEach(discussProjectItem => {

      const _key =discussProjectItem.name ? discussProjectItem.name : discussProjectItem.itemName;
			this.barChart3Labels.push(_key)
			this.barChart3Data.forEach((item, _index) => {
				this.barChart3Data[_index].mappingData[_key] = 0;
			});
		});
		for (var projectName in data) {
			this.barChart3Data.forEach((element, _idx) => {
				if (element.label == projectName && data[projectName].statistic_project.statistic.statistic.statistic) {
					data[projectName].statistic_project.statistic.statistic.statistic.buckets.forEach(item => {
						this.barChart3Data[_idx].mappingData[item.key] = item.doc_count;
					});
				}
			});
		}

		this.barChart3Data.forEach((element, _idx) => {
			for (var keyDiscussProject in element.mappingData) {
				this.barChart3Data[_idx].data.push(element.mappingData[keyDiscussProject]);
			}
		});
	}

  async mappingDataChart4(data) {
    this.sources = [];

		for (var brandName in data) {
					let totalFacebook = 0;
					let totalNews = 0;
					let totalForum = 0;
					let totalYoutube = 0;
					let totalTiktok = 0;
					let totalInstagram = 0;
					let totalLinkedin = 0;
          let totalTwitter = 0
					data[brandName].statistic.docTypesCount.filter.buckets.forEach(item => {
						if (item.key == 'comment' || item.key == 'page_post' || item.key == 'user_post' || item.key == 'group_post') {
							totalFacebook += item.doc_count;
						}
						if (item.key == 'news_article') {
							totalNews += item.doc_count;
						}
						if (item.key == 'news_blog') {
							totalForum += item.doc_count;
						}
						if (item.key == 'youtube' || item.key == 'youtube_comment') {
							totalYoutube += item.doc_count;
						}
						if (item.key == 'tiktok' || item.key == 'tiktok_comment') {
							totalTiktok += item.doc_count;
						}
						if (item.key == 'instagram' || item.key == 'instagram_comment') {
							totalInstagram += item.doc_count;
						}
						if (item.key == 'linkedin' || item.key == 'linkedin_comment') {
							totalLinkedin += item.doc_count;
						}
            if (item.key == 'twitter' || item.key == 'twwiter_comment') {
							totalTwitter += item.doc_count;
						}
					});	
          this.sources.push({
             brandName : brandName,
             totalFacebook : totalFacebook,
             totalNews : totalNews,
             totalForum : totalForum,
             totalYoutube : totalYoutube,
             totalTiktok : totalTiktok,
             totalInstagram : totalInstagram,
             totalLinkedin : totalLinkedin,
             totalTwitter: totalTwitter
          })
		}

	}

}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard8/dashboard8.component.ts